var _regeneratorRuntime = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _createClass = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _inherits = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _awaitAsyncGenerator = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/awaitAsyncGenerator.js");
var _wrapAsyncGenerator = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/wrapAsyncGenerator.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
require("core-js/modules/esnext.global-this.js");
/* replacement start */

var process = require('process/')

/* replacement end */;

'use strict';
var bufferModule = require('buffer');
var _require = require('./utils'),
  isReadable = _require.isReadable,
  isWritable = _require.isWritable,
  isIterable = _require.isIterable,
  isNodeStream = _require.isNodeStream,
  isReadableNodeStream = _require.isReadableNodeStream,
  isWritableNodeStream = _require.isWritableNodeStream,
  isDuplexNodeStream = _require.isDuplexNodeStream,
  isReadableStream = _require.isReadableStream,
  isWritableStream = _require.isWritableStream;
var eos = require('./end-of-stream');
var _require2 = require('../../ours/errors'),
  AbortError = _require2.AbortError,
  _require2$codes = _require2.codes,
  ERR_INVALID_ARG_TYPE = _require2$codes.ERR_INVALID_ARG_TYPE,
  ERR_INVALID_RETURN_VALUE = _require2$codes.ERR_INVALID_RETURN_VALUE;
var _require3 = require('./destroy'),
  destroyer = _require3.destroyer;
var Duplex = require('./duplex');
var Readable = require('./readable');
var Writable = require('./writable');
var _require4 = require('../../ours/util'),
  createDeferredPromise = _require4.createDeferredPromise;
var from = require('./from');
var Blob = globalThis.Blob || bufferModule.Blob;
var isBlob = typeof Blob !== 'undefined' ? function isBlob(b) {
  return b instanceof Blob;
} : function isBlob(b) {
  return false;
};
var AbortController = globalThis.AbortController || require('abort-controller').AbortController;
var _require5 = require('../../ours/primordials'),
  FunctionPrototypeCall = _require5.FunctionPrototypeCall;

// This is needed for pre node 17.
var Duplexify = /*#__PURE__*/function (_Duplex) {
  "use strict";

  _inherits(Duplexify, _Duplex);
  var _super = _createSuper(Duplexify);
  function Duplexify(options) {
    var _this;
    _classCallCheck(this, Duplexify);
    _this = _super.call(this, options);

    // https://github.com/nodejs/node/pull/34385

    if ((options === null || options === undefined ? undefined : options.readable) === false) {
      _this._readableState.readable = false;
      _this._readableState.ended = true;
      _this._readableState.endEmitted = true;
    }
    if ((options === null || options === undefined ? undefined : options.writable) === false) {
      _this._writableState.writable = false;
      _this._writableState.ending = true;
      _this._writableState.ended = true;
      _this._writableState.finished = true;
    }
    return _this;
  }
  return _createClass(Duplexify);
}(Duplex);
module.exports = function duplexify(body, name) {
  if (isDuplexNodeStream(body)) {
    return body;
  }
  if (isReadableNodeStream(body)) {
    return _duplexify({
      readable: body
    });
  }
  if (isWritableNodeStream(body)) {
    return _duplexify({
      writable: body
    });
  }
  if (isNodeStream(body)) {
    return _duplexify({
      writable: false,
      readable: false
    });
  }
  if (isReadableStream(body)) {
    return _duplexify({
      readable: Readable.fromWeb(body)
    });
  }
  if (isWritableStream(body)) {
    return _duplexify({
      writable: Writable.fromWeb(body)
    });
  }
  if (typeof body === 'function') {
    var _fromAsyncGen = fromAsyncGen(body),
      value = _fromAsyncGen.value,
      write = _fromAsyncGen.write,
      _final = _fromAsyncGen.final,
      destroy = _fromAsyncGen.destroy;
    if (isIterable(value)) {
      return from(Duplexify, value, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        write: write,
        final: _final,
        destroy: destroy
      });
    }
    var _then = value === null || value === undefined ? undefined : value.then;
    if (typeof _then === 'function') {
      var d;
      var promise = FunctionPrototypeCall(_then, value, function (val) {
        if (val != null) {
          throw new ERR_INVALID_RETURN_VALUE('nully', 'body', val);
        }
      }, function (err) {
        destroyer(d, err);
      });
      return d = new Duplexify({
        // TODO (ronag): highWaterMark?
        objectMode: true,
        readable: false,
        write: write,
        final: function final(cb) {
          _final( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return promise;
                case 3:
                  process.nextTick(cb, null);
                  _context.next = 9;
                  break;
                case 6:
                  _context.prev = 6;
                  _context.t0 = _context["catch"](0);
                  process.nextTick(cb, _context.t0);
                case 9:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 6]]);
          })));
        },
        destroy: destroy
      });
    }
    throw new ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
  }
  if (isBlob(body)) {
    return duplexify(body.arrayBuffer());
  }
  if (isIterable(body)) {
    return from(Duplexify, body, {
      // TODO (ronag): highWaterMark?
      objectMode: true,
      writable: false
    });
  }
  if (isReadableStream(body === null || body === undefined ? undefined : body.readable) && isWritableStream(body === null || body === undefined ? undefined : body.writable)) {
    return Duplexify.fromWeb(body);
  }
  if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
    var readable = body !== null && body !== undefined && body.readable ? isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
    var writable = body !== null && body !== undefined && body.writable ? isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
    return _duplexify({
      readable: readable,
      writable: writable
    });
  }
  var then = body === null || body === undefined ? undefined : body.then;
  if (typeof then === 'function') {
    var _d;
    FunctionPrototypeCall(then, body, function (val) {
      if (val != null) {
        _d.push(val);
      }
      _d.push(null);
    }, function (err) {
      destroyer(_d, err);
    });
    return _d = new Duplexify({
      objectMode: true,
      writable: false,
      read: function read() {}
    });
  }
  throw new ERR_INVALID_ARG_TYPE(name, ['Blob', 'ReadableStream', 'WritableStream', 'Stream', 'Iterable', 'AsyncIterable', 'Function', '{ readable, writable } pair', 'Promise'], body);
};
function fromAsyncGen(fn) {
  var _createDeferredPromis = createDeferredPromise(),
    promise = _createDeferredPromis.promise,
    resolve = _createDeferredPromis.resolve;
  var ac = new AbortController();
  var signal = ac.signal;
  var value = fn(_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _promise, _yield$_awaitAsyncGen, chunk, done, cb, _createDeferredPromis2;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 21;
            break;
          }
          _promise = promise;
          promise = null;
          _context2.next = 5;
          return _awaitAsyncGenerator(_promise);
        case 5:
          _yield$_awaitAsyncGen = _context2.sent;
          chunk = _yield$_awaitAsyncGen.chunk;
          done = _yield$_awaitAsyncGen.done;
          cb = _yield$_awaitAsyncGen.cb;
          process.nextTick(cb);
          if (!done) {
            _context2.next = 12;
            break;
          }
          return _context2.abrupt("return");
        case 12:
          if (!signal.aborted) {
            _context2.next = 14;
            break;
          }
          throw new AbortError(undefined, {
            cause: signal.reason
          });
        case 14:
          _createDeferredPromis2 = createDeferredPromise();
          promise = _createDeferredPromis2.promise;
          resolve = _createDeferredPromis2.resolve;
          _context2.next = 19;
          return chunk;
        case 19:
          _context2.next = 0;
          break;
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }))(), {
    signal: signal
  });
  return {
    value: value,
    write: function write(chunk, encoding, cb) {
      var _resolve = resolve;
      resolve = null;
      _resolve({
        chunk: chunk,
        done: false,
        cb: cb
      });
    },
    final: function final(cb) {
      var _resolve = resolve;
      resolve = null;
      _resolve({
        done: true,
        cb: cb
      });
    },
    destroy: function destroy(err, cb) {
      ac.abort();
      cb(err);
    }
  };
}
function _duplexify(pair) {
  var r = pair.readable && typeof pair.readable.read !== 'function' ? Readable.wrap(pair.readable) : pair.readable;
  var w = pair.writable;
  var readable = !!isReadable(r);
  var writable = !!isWritable(w);
  var ondrain;
  var onfinish;
  var onreadable;
  var onclose;
  var d;
  function onfinished(err) {
    var cb = onclose;
    onclose = null;
    if (cb) {
      cb(err);
    } else if (err) {
      d.destroy(err);
    }
  }

  // TODO(ronag): Avoid double buffering.
  // Implement Writable/Readable/Duplex traits.
  // See, https://github.com/nodejs/node/pull/33515.
  d = new Duplexify({
    // TODO (ronag): highWaterMark?
    readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
    writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
    readable: readable,
    writable: writable
  });
  if (writable) {
    eos(w, function (err) {
      writable = false;
      if (err) {
        destroyer(r, err);
      }
      onfinished(err);
    });
    d._write = function (chunk, encoding, callback) {
      if (w.write(chunk, encoding)) {
        callback();
      } else {
        ondrain = callback;
      }
    };
    d._final = function (callback) {
      w.end();
      onfinish = callback;
    };
    w.on('drain', function () {
      if (ondrain) {
        var cb = ondrain;
        ondrain = null;
        cb();
      }
    });
    w.on('finish', function () {
      if (onfinish) {
        var cb = onfinish;
        onfinish = null;
        cb();
      }
    });
  }
  if (readable) {
    eos(r, function (err) {
      readable = false;
      if (err) {
        destroyer(r, err);
      }
      onfinished(err);
    });
    r.on('readable', function () {
      if (onreadable) {
        var cb = onreadable;
        onreadable = null;
        cb();
      }
    });
    r.on('end', function () {
      d.push(null);
    });
    d._read = function () {
      while (true) {
        var buf = r.read();
        if (buf === null) {
          onreadable = d._read;
          return;
        }
        if (!d.push(buf)) {
          return;
        }
      }
    };
  }
  d._destroy = function (err, callback) {
    if (!err && onclose !== null) {
      err = new AbortError();
    }
    onreadable = null;
    ondrain = null;
    onfinish = null;
    if (onclose === null) {
      callback(err);
    } else {
      onclose = callback;
      destroyer(w, err);
      destroyer(r, err);
    }
  };
  return d;
}